<template>
  <b-modal
    :ref="'atualizarEmpresa'"
    hide-footer
    hide-header
    centered
    size="lg"
    no-close-on-backdrop
  >
    <b-row v-if="showEmpresas">
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="fechaSelecaoEmpresas"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="text-align:center;"
          >
            <h4>
              Escolha as empresas para adicionar o(s) documento(s)
            </h4>
          </b-col>
          <div
            class="mt-1 px-1"
            style="flex-grow:1"
          >
            <b-row>
              <b-col cols="12">
                <tabela-empresa
                  :modelo-id="modeloId"
                  @empresa-selecionada="selecionaEmpresas"
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="12">
                <b-btn
                  variant="success"
                  class="w-100"
                  @click="chamaAtualizaDocumentos"
                >Confirmar</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col>
        <b-row>
          <b-col
            cols="12"
            style="text-align:center"
          >
            <h2>
              Atenção!
            </h2>
            <h5> Deseja {{ adicionar ? 'incluir' : 'remover' }} o(s) documento(s) selecionados em todas as empresas que usam esse modelo?</h5>
          </b-col>
        </b-row>
        <b-row
          class="mt-1"
        >
          <b-col
            style="padding:0 3rem;text-align:center"
          >
            <b-btn
              variant="success"
              class="mr-50"
              @click="chamaAtualizaDocumentos()"
            >Sim</b-btn>
            <b-btn
              variant="primary"
              class="mr-50"
              @click="mostraEscolherEmpresas()"
            >Escolher</b-btn>
            <b-btn
              variant="danger"
              @click="fecharSemAtualizarEmpresas"
            >Não</b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<style lang="scss">
</style>

<script>
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'AtualizarEmpresa',
  components: {
    TabelaEmpresa: () => import('../visualizacao-empresa/VisualizacaoEmpresa.vue'),
  },
  props: {
    modeloId: {
      type: [String, Number],
      required: true,
    },
    multiplasEmpresas: {
      type: Boolean,
      required: true,
    },
    adicionar: {
      type: Boolean,
      required: true,
    },
    documentosForamAdicionados: {
      type: Boolean,
      default: false,
    },
    documentosForamRemovidos: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => { },
    },
  },
  data() {
    return {
      showEmpresas: false,
      empresasSelecionadas: [],
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.documentosForamAdicionados) {
        this.$refs.atualizarEmpresa.show()
      } else if (this.documentosForamRemovidos) {
        this.mostraMensagemRemocao()
      } else {
        this.fechar()
      }
    })
  },
  methods: {
    chamaAtualizaDocumentos() {
      if (this.documentosForamRemovidos) {
        this.mostraMensagemRemocao()
      } else {
        this.atualizaDocumentos()
      }
    },
    async atualizaDocumentos() {
      if (this.empresasSelecionadas.length === 0) {
        await this.selecionaTodasAsEmpresas()
      }

      this.$emit('show-loading')
      this.fechar()
    },
    mostraMensagemRemocao() {
      this.$swal({
        title: 'Atenção!',
        text: 'Os documentos removidos deste modelo somente serão excluídos nas empresas que não tem histórico de cobrança.\n'
              + 'Os documentos removidos serão inativados nas empresas que tem histórico de cobrança.\n'
              + 'Deseja continuar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.atualizaDocumentos()
        } else {
          this.fecharSemAtualizar()
        }
      })
    },
    async selecionaTodasAsEmpresas() {
      await apiEmpresa.getEmpresasPorModelo(this.modeloId).then(payload => {
        this.empresasSelecionadas = payload.data
      })
    },
    mostraEscolherEmpresas() {
      this.showEmpresas = true
    },
    selecionaEmpresas(empresas) {
      this.empresasSelecionadas = empresas
    },
    fechaSelecaoEmpresas() {
      this.showEmpresas = false
      this.empresasSelecionadas = []
    },
    fechar() {
      this.showEmpresas = false
      this.$refs.atualizarEmpresa.hide()
      this.$emit('hide', this.empresasSelecionadas)
    },
    fecharSemAtualizar() {
      this.showEmpresas = false
      this.$refs.atualizarEmpresa.hide()
      this.$emit('cancel')
    },
    fecharSemAtualizarEmpresas() {
      this.showEmpresas = false
      this.$refs.atualizarEmpresa.hide()
      this.$emit('fechar-sem-atualizar')
    },
  },
}
</script>
